import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions'
import { connect } from 'react-redux';
import {MessageBar, MessageBarType, PrimaryButton, ProgressIndicator} from '@fluentui/react';
import { Redirect } from "react-router-dom";
import { SET_ORDER_CREATED } from "../../../actions/types";
import {freezeWizard} from "../../../actions/WizardActions/FreezeWizard";
import InfoTable from '../Step1/InfoTable';
import { setNavigation } from '../../../actions/appActions';
import Api from '../../../services/Api'
import { msTeamsProvisionerApp, limitVersioning } from "../../../GlobalConst/globalConst";
import { createTeamsDeepLink } from "../../../helpers/HelperMethods";
import * as microsoftTeams from "@microsoft/teams-js";


class Summary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            createMessage: false,
            createFail: null,
            isLoading: false
        }
    }

    setRedirect = (navigationUrl) => {
        navigationUrl += this.props.isMsTeams ? '#MyTeams' : '#MySites';

        this.setState({ redirect: navigationUrl });
        this.props.setNavigation(navigationUrl);
    }

    determineAddress()
    {
        if(this.props.template.approvalRequired)
        {
            return '/CreatePreliminarySite'
        }
        else return '/CreateSiteRequest'
    }

    sendRequest(element) {
        this.setState({ isLoading: true, createMessage: false})
        this.props.freeze(true);
        const locationPart = this.determineAddress();
        Api.post(locationPart, element)
            .then(res => res.data)
            .then(post => {
                this.props.freeze(false);
                this.setState({ isLoading: false })
                if (post === 200) {
                    this.props.setCreated(SET_ORDER_CREATED, true);
                    this.setState({createMessage: true, createFail: false })
                }
                else {
                    this.setState({createMessage: true, createFail: true })
                }
            }
            ).catch((error) => {
                this.setState({ isLoading: false })
                console.log(error)
                this.props.freeze(false);
            })
    }

    orderSite() {
        const post = {
            name: this.props.name,
            title: this.props.title,
            confidentiality: this.props.confidentiality,
            externalCollaboration: this.props.externalCollaboration,
            quotaValue: this.props.quotaSize,
            purpose: this.props.purpose,
            owner: this.props.owner,
            coOwners: [this.props.coOwners],
            siteApprover: this.props.approver,
            author: this.props.currentUser,
            gdpr: this.props.gdpr,
            sensitiveGdpr : this.props.sensitiveGdpr,
            templateId: this.props.template.id,
            templateName:this.props.template.name,
            locationId: this.props.location.id,
            geographyKey: this.props.geography.key,
            managementKey: this.props.management.key,
            PMO: this.props.PMOs,
            projectManager: this.props.projectManager,
            sponsor: this.props.sponsor,
            steeringCommittee: this.props.steeringCommittee,
            members: this.props.members,
            idgIntegration: this.props.idgIntegration
        }
        this.sendRequest(post);
    }

    render() {
        const message = this.state.createMessage
            ? (this.state.createFail 
                ?   
                <MessageBar messageBarType={MessageBarType.error}>
                    Order was not created. Please send order again or contact support team.
                </MessageBar> 
                :
                <MessageBar messageBarType={MessageBarType.success}>
                    Your order has been created. You may <span className="redirect-link" onClick={() => this.setRedirect('ManageCenter')}>check order status</span> here.
                </MessageBar>) 
            : null;

        const buttons = !this.props.created && !this.state.isLoading 
                                ? <div className='nav-button-summary'>
                                    <PrimaryButton onClick={this.orderSite.bind(this)}>Order</PrimaryButton>
                                  </div> 
                                : null;

        if (this.state.redirect) {
            if (this.props.isMsTeamsApp) {
                const deepLink = createTeamsDeepLink(msTeamsProvisionerApp.id, msTeamsProvisionerApp.manageCenterTabId, this.state.redirect, true);
                microsoftTeams.executeDeepLink(deepLink);
            } 
            else {
                return <Redirect to={this.state.redirect} />;
            }
        }

        return (
            
            <div className='wizard-inside' >
                 <div style={{height :'580px', overflowY : 'auto'}}>  
                <table id='summary' >
                    <tbody>
                        <tr>
                            <td className='col-md-6'>Site Name: </td>
                            <td className='col-md-6'>{this.props.title}</td>
                        </tr>
                        <tr>
                            <td className='col-md-6'>Site URL:</td>
                            <td className='col-md-6'>
                                <div>{this.props.url}</div>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>Location: </td>
                            <td>{this.props.location.name}</td>
                        </tr> */}
                        <tr>
                            <td>Template: </td>
                            <td>{this.props.template.name}</td>
                        </tr>
                        <tr>
                            <td>Sensitivity Label:</td>
                            <td>{this.props.confidentiality}</td>
                        </tr>
                        {
                            !this.props.onPremise &&
                            <tr>
                                <td>External Collaboration: </td>
                                <td>{this.props.externalCollaboration ? "Yes" : "No"}</td>
                            </tr>
                        }
                        <tr>
                            <td>Starting Quota: </td>
                            <td>{this.props.quotaSize < 1000 ? this.props.quotaSize + ' GB' : Math.round(this.props.quotaSize/1000) + ' TB'}</td>
                        </tr>
                        <tr>
                            <td>File versioning: </td>
                            <td>Enabled, {limitVersioning.versionsLimit} count limit, {limitVersioning.versionsDays} days count limit</td>
                        </tr>
                        <tr>
                            <td>Site Audience: </td>
                            <td>{this.props.geography && this.props.geography.value}</td>
                        </tr>
                        <tr>
                            <td>Business Unit: </td>
                            <td>{this.props.management && this.props.management.value}</td>
                        </tr>
                        <tr>
                            <td>GDPR restrictions: </td>
                            <td>{this.props.gdpr ? 'Yes' : 'No'}</td>
                        </tr>
                        {this.props.gdpr?  <tr>
                            <td>Sensitive Personal Data: </td>
                            <td>{this.props.sensitiveGdpr ? 'Yes' : 'No'}</td>
                        </tr> : null}
                        {!(this.props.isIATU || this.props.isIAPCP) ? <tr>
                            <td>Administrator: </td>
                            <td>{this.props.owner && this.props.owner.displayName}</td>
                        </tr>: null}

                        {!(this.props.isIATU || this.props.isIAPCP || (this.props.template.config || {}).hideApprover) ? <tr>
                            <td>Approver: </td>
                            <td>{this.props.approver && this.props.approver.displayName}</td>
                        </tr> : null}

                        {this.props.isIATU || this.props.isIAPCP? <tr>
                            <td>PMO: </td>
                            <td>{this.props.PMOs && this.props.PMOs.map(e => e === null ? "" : e.displayName).join(", ")}</td>
                        </tr> : null}

                        {this.props.isIATU  || this.props.isIAPCP? <tr>
                            <td>Project Manager: </td>
                            <td>{this.props.projectManager && this.props.projectManager.map(e => e === null ? "" : e.displayName).join(", ")}</td>
                        </tr> : null}

                        {this.props.isIATU  || this.props.isIAPCP? <tr>
                            <td>Sponsor: </td>
                            <td>{this.props.sponsor && this.props.sponsor.map(e => e === null ? "" : e.displayName).join(", ")}</td>
                        </tr> : null}

                        {this.props.isIATU  || this.props.isIAPCP? <tr>
                            <td>Steering committee: </td>
                            <td>{this.props.steeringCommittee && this.props.steeringCommittee.map(e => e.displayName).join(", ")}</td>
                        </tr> : null}

                        {this.props.isIATU || this.props.isIAPCP ? <tr>
                            <td>Members: </td>
                            <td>{this.props.members && this.props.members.map(e => e.displayName).join(", ")}</td>
                        </tr> : null}


                    </tbody>
                </table>
                </div>   
                <InfoTable isSummaryInfo={true}/>
                {this.state.isLoading ?
                    <div style={{ marginTop: '20px' }}>
                    <ProgressIndicator  description="Your request is processing" />  </div> : null
                }
                <div style={{ marginTop: '20px' }}>
                    {message}
                </div>
                {!this.props.created ? buttons : null}
            </div>
        );
    }
}

const mapActionToProp =
{
    setCreated: addElement,
    freeze: freezeWizard,
    setNavigation
}

const mapStateToProps = state => ({
    onPremise: state.newSite.OnPremiseState,
    title: state.newSite.Title,
    name: state.newSite.Name,
    confidentiality: state.newSite.Confidentiality,
    externalCollaboration: state.newSite.ExternalCollaboration,
    quotaSize: state.newSite.QuotaSize,
    postSuccess: state.response.Success,
    geography: state.newSite.geography,
    management: state.newSite.management,
    created: state.newSite.OrderCreated,
    purpose: state.newSite.Purpose,
    gdpr: state.newSite.Gdpr,
    sensitiveGdpr: state.newSite.SensitiveGdpr,
    owner: state.newSite.Owner,
    coOwners: state.newSite.coOwners,
    approver: state.newSite.Approver,
    template: state.newSite.Template,
    location: state.newSite.Location,
    currentUser: state.user.currentUser,
    isMsTeams: state.newSite.isMsTeams,
    isMsTeamsApp: state.app.isMsTeamsApp,
    isIATU: state.newSite.isIATU,
    PMOs: state.newSite.PMOs,
    projectManager: state.newSite.ProjectManager,
    sponsor: state.newSite.Sponsor,
    steeringCommittee: state.newSite.SteeringCommittee,
    members: state.newSite.Members,
    isIAPCP: state.newSite.isIAPCP,
    url: state.newSite.Url,
    idgIntegration: state.newSite.idgIntegration
})

export default connect(mapStateToProps, mapActionToProp)(Summary);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step6/Summary.js